import { createSlice } from '@reduxjs/toolkit';
import { addCoachUsers, deleteCoachUser, getCoachUsers } from './userAccessActions';

const initialState = {
  isLoading: false,
  employees: [],
  error: null,
  success: false,
};

const userAccessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {},
  extraReducers: {
    // get employees
    [getCoachUsers.pending]: state => {
      state.isLoading = true;
    },
    [getCoachUsers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.employees = payload.data;
    },
    [getCoachUsers.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // add employees
    [addCoachUsers.pending]: state => {
      // state.isLoading = true;
    },
    [addCoachUsers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      // state.employees = payload.data;
    },
    [addCoachUsers.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // delete employee
    [deleteCoachUser.pending]: state => {
      // state.isLoading = true;
    },
    [deleteCoachUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.employees = state.employees.filter(
        emp => emp.id !== payload.userId
      );
    },
    [deleteCoachUser.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export default userAccessSlice.reducer;
